import React from "react";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Button } from "@mui/material";

const Conference = () => {
  return (
    <div className="m-4">
      <div className="flex flex-col justify-between m-4 lg:basis-1/2 shrink">
        <div className="text-xl md:text-3xl font-semibold text-center">
          <div className="mt-8 text-red-600">
            <span className="text-xl md:text-2xl font-semibold">
              <EventAvailableIcon sx={{ width: "50px", height: "50px" }}/> 29 Sept - 3 Oct, 2025
            </span>
          </div>
          <div className="mt-4">
            <div className="text-gray-700">
              <LocationOnIcon sx={{width: "30px", height: "50px"}}/> 29 Sept, Building 6 (Smart Building), UOW, Wollongong, NSW, AUSTRALIA
            </div>
            <div className="text-gray-700">
              <LocationOnIcon sx={{width: "30px", height: "50px"}}/> 30 Sept - 2 Oct, Novotel, 2/14 Cliff Rd, Wollongong Northbeach, NSW, AUSTRALIA
            </div>
            <div className="text-gray-700">
              <LocationOnIcon sx={{width: "30px", height: "50px"}}/> 3 Oct, Southcoast, Wollongong, NSW, AUSTRALIA
            </div>
          </div>
          <div className="m-4">
            <a href="https://pay.uow.edu.au/InternationalConferenceonAdvancedManufacturing" target="_blank" rel="noopener noreferrer">
              <Button variant="outlined" color="secondary" sx={{
                bgcolor: "#EB9A3E", color: "#003366", "&:hover": {
                  bgcolor: "#EB9A3E", opacity: 0.8
                }, width: "200px", height: "60px", borderRadius: 0, border: 0, fontWeight: 900,
              }}>REGISTER NOW</Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Conference;